import { FC, MouseEventHandler } from 'react';

import { IconEdit } from '@purpur/library/icon/edit';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';
import {
    CellDetail,
    CellPrice,
    CellPriceText,
    CellTitle,
    DisneyIcon,
    VasEntryListItem,
    VasSwitch,
} from './entries.styles';

type DisneyVasProps = {
    isPremium: boolean;
    premiumPrice: Price;
    showDescription?: boolean;
    onChange?: MouseEventHandler<HTMLButtonElement>;
    isLoading?: boolean;
};

export const DisneyVas: FC<DisneyVasProps> = ({
    isPremium,
    premiumPrice,
    showDescription = true,
    onChange,
    isLoading,
}) => {
    const { t } = useTranslations();
    const title = isPremium ? t['order_cart.entry_disney.title.premium'] : t['order_cart.entry_disney.title.standard'];
    const description = isPremium
        ? t['order_cart.entry_disney.description.premium']
        : t['order_cart.entry_disney.description.standard'];
    const switchText = isPremium
        ? t['order_cart.entry_disney.change_to_standard']
        : t['order_cart.entry_disney.change_to_premium'];
    const standardPriceLabel = t['order_cart.entry_disney.price.standard_v2'];

    return (
        <VasEntryListItem data-test={ORDER_CART_ENTRY_ID.DISNEY_VAS} aria-label={title}>
            <DisneyIcon />
            <CellTitle>{title}</CellTitle>
            <CellDetail>{showDescription ? description : null}</CellDetail>
            {isPremium ? (
                <CellPrice price={premiumPrice} isMonthly={true} dataTest={ORDER_CART_TEST_ID.DISNEY_VAS_PRICE} />
            ) : (
                <CellPriceText data-test={ORDER_CART_TEST_ID.DISNEY_VAS_PRICE}>{standardPriceLabel}</CellPriceText>
            )}
            {!!onChange && (
                <VasSwitch
                    onClick={onChange}
                    loading={isLoading}
                    variant="text"
                    size="lg"
                    data-test={ORDER_CART_TEST_ID.ENTRY_ACTION}
                >
                    <IconEdit size="xs" />
                    {switchText}
                </VasSwitch>
            )}
        </VasEntryListItem>
    );
};
